import lazyLoading from './lazyLoading'

export default {
  name: 'config',
  meta: {
    expanded: false,
    title: 'Configuración',
    iconClass: 'vuestic-icon vuestic-icon-settings'
  },
  children: [
    {
      name: 'configUsers',
      path: '/config-users',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Usuarios'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/UserList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/UserNew'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':userId',
          component: lazyLoading('config/UserView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'travels/:userId',
          component: lazyLoading('config/UserTravelsView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'logs/:userId',
          component: lazyLoading('config/UserLogsView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      name: 'configClients',
      path: '/config-clients',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Clientes'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ClientList'),
          meta: {
            title: 'Clientes'
          }
        },
        {
          path: 'new', // Default route
          props: true,
          component: lazyLoading('config/ClientView'),
          meta: {
            title: 'Clientes'
          }
        },
        {
          path: ':clientId',
          component: lazyLoading('config/ClientView'),
          props: true,
          meta: {
            title: 'Clientes'
          }
        }
      ]
    },
    {
      name: 'configPermissions',
      path: '/config-permissions',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Permisos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/PermissionList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          props: true,
          component: lazyLoading('config/PermissionView'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':permissionId',
          component: lazyLoading('config/PermissionView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      name: 'configAirports',
      path: '/config-airports',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aeropuertos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/AirportList'),
          meta: {
            title: 'Aeropuertos'
          }
        },
        {
          path: 'new', // Default route
          props: true,
          component: lazyLoading('config/AirportView'),
          meta: {
            title: 'Aeropuertos'
          }
        },
        {
          path: ':airportId',
          component: lazyLoading('config/AirportView'),
          props: true,
          meta: {
            title: 'Aeropuertos'
          }
        }
      ]
    },
    {
      name: 'configZoneprices',
      path: '/config-zoneprices',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Precios de Zona'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ZonePriceList'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: 'new', // Default route
          props: true,
          component: lazyLoading('config/ZonePriceNew'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':zonePriceId',
          component: lazyLoading('config/ZonePriceNew'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        }
      ]
    },
    {
      name: 'configChargeIntents',
      path: '/config-charge-intents',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Intentos de Cargo'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ChargeIntentList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: ':intentId',
          component: lazyLoading('config/ChargeIntentView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        },
      ]
    },
    {
      name: 'configTelegramUsers',
      path: '/config-telegram-users',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Usuarios Telegram'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/TelegramUserList'),
          meta: {
            title: 'menu.drivers'
          }
        },
      ]
    },
    /*
    {
      path: '/driver-cards/',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'menu.drivers'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/DriverCa'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('config/DriverCard'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    */
    {
      name: 'configDrivers',
      path: '/config-drivers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'menu.drivers'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/DriverNew'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('config/DriverView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    // {
    //   path: '/config-driver',
    //   component: lazyLoading('config/Main'),
    //   meta: {
    //     title: 'Nuevo'
    //   },
    //   children: [
    //     {
    //       path: 'new', // Default route
    //       component: lazyLoading('config/DriverNew'),
    //       meta: {
    //         title: 'Nuevo'
    //       }
    //     }
    //   ]
    // },
    {
      name: 'configHolders',
      path: '/config-holders',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Permisionarios'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/HolderList'),
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: ':holderId',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        }
      ]
    },
    {
      name: 'configOwners',
      path: '/config-owners',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Dueños'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/OwnersList'),
          meta: {
            title: 'Dueños'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/OwnerNew'),
          meta: {
            title: 'Dueños'
          }
        },
        {
          path: ':ownerId',
          component: lazyLoading('config/OwnerView'),
          props: true,
          meta: {
            title: 'Dueños'
          }
        }
      ]
    },
    {
      name: 'configSupervisors',
      path: '/config-supervisors',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Administradores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/SupervisorsList'),
          meta: {
            title: 'Administradores'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/SupervisorNew'),
          meta: {
            title: 'Administradores'
          }
        },
        {
          path: ':supervisorId',
          component: lazyLoading('config/SupervisorView'),
          props: true,
          meta: {
            title: 'Administradores'
          }
        }
      ]
    },
    {
      name: 'configCompanies',
      path: '/config-companies',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Compañías'
      },
      children: [
        {
          // name: 'Companies',
          path: '', // Default route
          component: lazyLoading('config/CompanyList'),
          meta: {
            title: 'Compañías'
          }
        },
        {
          path: 'new', // Default route
          props: true,
          component: lazyLoading('config/CompanyView'),
          meta: {
            title: 'Compañías'
          }
        },
        {
          path: ':companyI',
          component: lazyLoading('config/CompanyView'),
          props: true,
          meta: {
            title: 'Compañías'
          }
        },
        // {
        //   name: 'PanelCompany',
        //   path: ':companyId/panel',
        //   component: lazyLoading('companies/Main'),
        //   props: true,
        //   meta: {
        //     title: 'Panel'
        //   },
        //   children: [
        //     {
        //       name: 'OpenedTravelCompany',
        //       path: 'opened', // Default route
        //       component: lazyLoading('companies/panel/openedTravels'),
        //       meta: {
        //         title: 'Lista de Compañías'
        //       }
        //     },
        //     {
        //       name: 'AirportPendingCompany',
        //       path: 'airport', // Default route
        //       component: lazyLoading('companies/panel/airportTravels'),
        //       meta: {
        //         title: 'Por Abordar En Aeropuerto'
        //       }
        //     },
        //     {
        //       name: 'ReturnTravelCompany',
        //       path: 'return', // Default route
        //       component: lazyLoading('companies/panel/returnTravels'),
        //       meta: {
        //         title: 'De Regreso'
        //       }
        //     },
        //     {
        //       name: 'CityQueueCompany',
        //       path: 'city', // Default route
        //       component: lazyLoading('companies/panel/cityQueues'),
        //       meta: {
        //         title: 'Solicitudes de Ciudad'
        //       }
        //     },
        //     {
        //       name: 'FinishedTravelCompany',
        //       path: 'finished', // Default route
        //       component: lazyLoading('companies/panel/finishedTravels'),
        //       meta: {
        //         title: 'Viajes Finalizados'
        //       }
        //     },
        //     {
        //       name: 'CarsCompany',
        //       path: 'cars', // Default route
        //       component: lazyLoading('companies/panel/cars'),
        //       meta: {
        //         title: 'Flota'
        //       }
        //     },
        //     {
        //       name: 'MonitorCompany',
        //       path: 'monitor', // Default route
        //       component: lazyLoading('companies/panel/monitor'),
        //       meta: {
        //         title: 'Monitor'
        //       }
        //     },
        //   ]
        // },
      ]
    },
    {
      name: 'configCompanyServices',
      path: '/config-company-services',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Servicios de Compañía'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/CompanyServicesList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/CompanyServicesView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':companyServiceId',
          component: lazyLoading('config/CompanyServicesView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        },
      ]
    },
    {
      name: 'configCars',
      path: '/config-cars',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Vehículos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/CarsList'),
          meta: {
            title: 'Vehículos'
          }
        },
        {
          path: ':carId',
          component: lazyLoading('config/CarView'),
          props: true,
          meta: {
            title: 'Vehículo'
          }
        }
      ]
    },
    {
      name: 'configModulators',
      path: '/config-modulators',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Moduladores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ModulatorList'),
          meta: {
            title: 'Modulador'
          }
        },
        {
          path: ':userId',
          component: lazyLoading('config/ModulatorView'),
          props: true,
          meta: {
            title: 'Modulador'
          }
        }
      ]
    },
    {
      name: 'configVirtual',
      path: '/config-virtual',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Colas Asistidas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/VirtualList'),
          meta: {
            title: 'Colas Asistidas'
          }
        },
        {
          path: ':virtualId',
          component: lazyLoading('config/VirtualView'),
          meta: {
            title: 'Colas Asistidas'
          }
        }
      ]
    },
    {
      name: 'updateHolders',
      path: '/utils/updateHolders',
      component: lazyLoading('tools/updateHolders'),
      meta: {
        title: 'Actualizar Permisionario',
        requiresAuth: true
      }
    },
    {
      name: 'updateDrivers',
      path: '/utils/updateDrivers',
      component: lazyLoading('tools/updateDrivers'),
      meta: {
        title: 'Actualizar Conductores',
        requiresAuth: true
      }
    },
    {
      name: 'updateCars',
      path: '/utils/updateCars',
      component: lazyLoading('tools/updateCars'),
      meta: {
        title: 'Actualizar Vehiculo',
        requiresAuth: true
      }
    },
    {
      name: 'configPromoRedeem',
      path: '/config-promo-redeem',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Promociones Canjeadas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/PromoRedeemList'),
          meta: {
            title: 'menu.drivers'
          }
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/config.js